import type { PdfTemplateDesign } from "@workspace/api-zod/pdf-template";
import { TITLE_FONTS } from "@/lib/pdf-template-fonts";
import "./pdf-title-fonts.css";

export function PdfTitleFontPicker({ value, onChange }: {
  value: PdfTemplateDesign["titleFont"];
  onChange: (value: NonNullable<PdfTemplateDesign["titleFont"]>) => void;
}) {
  return (
    <fieldset className="space-y-2" data-testid="title-font-picker">
      <legend className="text-sm font-medium">Title font</legend>
      <p className="text-xs leading-relaxed text-muted-foreground">Used for your company name, cover title and thank-you title. Quote details keep their original font.</p>
      <div className="grid grid-cols-3 gap-2">
        {TITLE_FONTS.map(font => (
          <label key={font.value} className={`relative flex cursor-pointer flex-col items-center rounded-md border p-2 text-center ${ (value ?? "helvetica") === font.value ? "border-primary bg-primary/10 ring-1 ring-primary" : "hover:bg-muted/50" }`}>
            <input type="radio" name="pdf-title-font" value={font.value} checked={(value ?? "helvetica") === font.value}
              onChange={() => onChange(font.value)} className="sr-only peer" data-testid={`radio-title-font-${font.value}`} />
            <span aria-hidden="true" className="text-2xl leading-tight peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-primary" style={{ fontFamily: font.css, fontWeight: 700 }}>Aa</span>
            <span className="mt-1 text-[11px] font-medium leading-tight">{font.label}</span>
            <span className="mt-1 text-[10px] text-muted-foreground">{font.detail}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
